var $3d85b21727aef233$exports = {};
$3d85b21727aef233$exports = {
    "placeholder": `Select\u{2026}`,
    "loading": `Loading\u{2026}`
};


export {$3d85b21727aef233$exports as default};
//# sourceMappingURL=en-US.module.js.map
